import { useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { useGetService } from "../../api/queries/useGetService";

import { GoHireHeader } from "../../components/GoHireHeader";
import ServiceSummary from "../../components/ServiceSummary";
import RequestSubmittedModal from "../../components/RequestSubmittedModal";

import ServiceReviews from "./ServiceReviews";
import ProviderDetails from "./ProviderDetails";
import ServiceDescription from "./ServiceDescription";

const ServicePage = () => {
  const { serviceId } = useParams();

  const { data: service, isLoading: isServiceLoading } = useGetService(Number(serviceId));

  const [isRequestSubmittedModalOpen, setIsRequestSubmittedModalOpen] = useState(false);

  const handleRequestSubmittedModal = () => setIsRequestSubmittedModalOpen(true);
  const handleCloseRequestSubmittedModal = () => setIsRequestSubmittedModalOpen(false);

  return (
    <>
      <Box sx={styles.container}>
        <Box sx={styles.contentContainer}>
          <GoHireHeader
            service={service}
            isServiceLoading={isServiceLoading}
            handleRequestSubmittedModal={handleRequestSubmittedModal}
          />
          <Box sx={styles.serviceDetailsContainer}>
            <ServiceDescription service={service} isServiceLoading={isServiceLoading} />
            {/* <ServiceAvailability service={service} isServiceLoading={isServiceLoading} /> */}
            <ProviderDetails service={service} isServiceLoading={isServiceLoading} />
            <ServiceReviews service={service} isServiceLoading={isServiceLoading} />
          </Box>
        </Box>
        <ServiceSummary
          service={service}
          isServiceLoading={isServiceLoading}
          handleRequestSubmittedModal={handleRequestSubmittedModal}
        />
      </Box>
      <RequestSubmittedModal open={isRequestSubmittedModalOpen} closeModal={handleCloseRequestSubmittedModal} />
    </>
  );
};

export default ServicePage;

const styles = {
  container: {
    display: "flex",
    flexDirection: { xs: "column", lg: "row" },
    gap: "10px",
    width: "100%",
  },
  contentContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    justifyContent: "space-between",
    width: { xs: "100%", lg: "553px" },
  },
  serviceDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
};
